import { type PlantCategory } from '@common/types/plant';
import { type ResourceCategory } from '@common/types/resource';
import { plantImages, resourceImages } from '@components/helpers/imagesImports';

import { getGoodIcon } from './getGoodIcon';

const getIcon = (item: string): { png: string; webp?: string } | null => {
  const newResourceImages = resourceImages as Record<string, ResourceCategory>;
  const newPlantImages = plantImages as Record<string, PlantCategory>;

  const images =
    item in newResourceImages
      ? newResourceImages[item]
      : item in newPlantImages
        ? newPlantImages[item]
        : null;
  const image = !images
    ? getGoodIcon(item)
    : 'icon' in images
      ? (images.icon as { png: string; webp: string })
      : null;

  return typeof image === 'string' ? { png: image } : image;
};

export { getIcon };
